<template>
  <checkbox-multi-select
    :label="label"
    :required="required"
    :labelSmall="labelSmall"
    :options="optionList"
    v-model="selected"
    trackBy="id"
    ref="multiSelectRef"
    displayField="name"
    :style="{ marginTop: '-6px' }"
    @filtering="search($event.text)"
    @select="selectItem"
    @open="fetchValue()"
    @removed="removedItem"
  >
  </checkbox-multi-select>
</template>
<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { service_paths, service_names } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

export default {
  components: { CheckboxMultiSelect },
  props: ["label", "defaultSelected", "objectType", "required", "labelSmall"],
  model: {
    prop: "selectedValue",
    event: "changeValue"
  },
  data() {
    return {
      optionList: [],
      selected: [],
      memorizedSelected: []
    };
  },
  created() {
    if (this.defaultSelected.length) {
      this.memorizedSelected = this.defaultSelected.map(item => {
        return {
          id: this.objectType === "grade" ? this.getName(item) : getId(item),
          name: this.getName(item)
        };
      });
      this.optionList = [this.optionList, ...this.memorizedSelected];
      this.selected = this.memorizedSelected.map(item => item.id);
    }
  },
  watch: {
    objectType(value) {
      this.memorizedSelected = [];
      this.selected = [];
    }
  },
  computed: {
    ...mapGetters("user", ["info", "role"]),
    debounceSearchKey() {
      const self = this;
      return debounce(function(query) {
        self.fetchValue(query);
      }, 500);
    },
    apiPath() {
      let path = {
        class: `${service_paths.classes}`,
        term: `${service_paths.terms}`,
        grade: `${service_paths.grades}`,
        program: `${service_paths.programs}`,
        student: `${service_paths.students}/filter`,
        family: `${service_paths.families}/filter`,
        teacher: `${service_paths.staffs}/filter?role_names=Teacher`,
        role: `${service_paths.roles}`
      };
      if (hasValidRole(this.role, Role.Teacher)) {
        path.class = `${service_paths.users}/${getId(this.info)}/classes`;
        path.student = `${service_paths.students}/management-teacher/${getId(
          this.info
        )}`;
        path.family = `${service_paths.families}/teacher/${getId(this.info)}`;
      }
      return path;
    }
  },
  methods: {
    search(value) {
      this.debounceSearchKey(value);
    },
    getName(item) {
      if (this.objectType === "student") {
        return `${item.full_name} - ${item.student_code}`;
      }
      if (this.objectType === "family") {
        return `${item.full_name} - ${item.username}`;
      }
      if (this.objectType === "teacher") {
        return `${item.full_name} - ${item.staff_code}`;
      }
      return item.name;
    },
    updateValue() {
      this.$emit("changeValue", this.memorizedSelected);
    },
    selectItem(event) {
      this.memorizedSelected.push(event.itemData);
      this.updateValue();
    },
    removedItem(event) {
      const { itemData } = event;
      this.memorizedSelected = this.memorizedSelected.filter(
        item => item.id !== itemData.id
      );
      this.updateValue();
    },
    fetchValue(searchKey) {
      this.optionList = [];
      let param = {
        limit: 10
      };
      switch (this.objectType) {
        case "class":
        case "term":
        case "grade":
        case "program":
        case "role":
          {
            param["name__~"] = searchKey;
          }
          break;
        case "student":
          {
            param.search_key = searchKey;
            param.fields = ["full_name", "student_code"];
          }
          break;
        case "family":
          {
            param.search_key = searchKey;
            param.fields = ["full_name", "username"];
          }
          break;
        case "teacher": {
          param.search_key = searchKey;
          param.fields = ["full_name", "staff_code"];
        }
      }
      return this.$axios
        .get(
          this.apiPath[this.objectType],
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          if (response.data.data.length) {
            let resultList = response.data.data.map(item => {
              return {
                id:
                  this.objectType === "grade"
                    ? this.getName(item)
                    : getId(item),
                name: this.getName(item)
              };
            });
            resultList = resultList.filter(
              item =>
                !this.memorizedSelected
                  .map(selectedItem => selectedItem.id)
                  .includes(item.id)
            );
            if (this.objectType === "role") {
              resultList = resultList.filter(
                item =>
                  item.name !== Role.Teacher &&
                  item.name !== Role.Student &&
                  item.name !== Role.Family
              );
            }
            this.optionList = [...this.memorizedSelected, ...resultList];
            this.selected = this.memorizedSelected.map(item => item.id);
          }
        });
    }
  }
};
</script>
